/* unplugin-vue-components disabled */import { render } from "./user-contacts.vue?vue&type=template&id=f56d007a&scoped=true"
import script from "./user-contacts.vue?vue&type=script&lang=js"
export * from "./user-contacts.vue?vue&type=script&lang=js"

import "./user-contacts.vue?vue&type=style&index=0&id=f56d007a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56d007a"],['__file',"src/pages/tenants/user/contacts/user-contacts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f56d007a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f56d007a', __exports__)) {
    api.reload('f56d007a', __exports__)
  }
  
  module.hot.accept("./user-contacts.vue?vue&type=template&id=f56d007a&scoped=true", () => {
    api.rerender('f56d007a', render)
  })

}


export default __exports__